import { createContext } from 'react';

export interface IGlobalErrorContext {
  showAppInitializationErrorModal: () => void;
  addErrorModal: any;
  closeErrorModal: any;
  showErrorModal: boolean;
}

export const GlobalErrorContext = createContext({} as IGlobalErrorContext);
